import { PatientBasicsDto } from '../../api/generated/model';
import { PatientSideListSearchWorkerMessageData } from './patientSideListSearchShared.ts';

const AMOUNT_OF_PATIENT_SEARCH_WORKERS = 2;
const workers = createWorkers();
let currentWorker = 0;
const runningSearches: Map<string, (value: PatientBasicsDto[]) => unknown> = new Map();
let haveWorkersBeenInitialized = false;

export const updatePatientSideListSearchData = (patients: PatientBasicsDto[]) => {
  const message: PatientSideListSearchWorkerMessageData = { type: 'initialize', value: patients };
  workers.forEach((worker) => worker.postMessage(message));
  haveWorkersBeenInitialized = true;
};

export const searchSideListPatient = (params: string): Promise<PatientBasicsDto[]> => {
  if (!haveWorkersBeenInitialized) {
    throw new Error("Workers haven't been initialized with patient data yet.");
  }
  const message: PatientSideListSearchWorkerMessageData = {
    type: 'search',
    value: params,
    id: getSearchKey(currentWorker),
  };
  workers[currentWorker].postMessage(message);
  currentWorker = (currentWorker + 1) % AMOUNT_OF_PATIENT_SEARCH_WORKERS;

  return new Promise((resolve) => runningSearches.set(message.id, resolve));
};

function createWorkers() {
  const workers = Array(AMOUNT_OF_PATIENT_SEARCH_WORKERS)
    .fill(undefined)
    .map(
      () =>
        new Worker(new URL('./patientSideListSearchWorker.ts', import.meta.url), {
          type: 'module',
        }),
    );
  workers.forEach((worker) => {
    worker.addEventListener('message', ({ data: message }: MessageEvent<PatientSideListSearchWorkerMessageData>) => {
      if (message.type === 'result' && runningSearches.has(message.id)) {
        runningSearches.get(message.id)?.(message.value);
        runningSearches.delete(message.id);
      }
    });
  });
  return workers;
}

const getSearchKey = (currentWorker: number) => `${Date.now()}_${Math.round(performance.now() * 10)}_${currentWorker}`;
